














































































































































































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import LinkVariantIcon from 'vue-material-design-icons/LinkVariant.vue';
import InformationOutlineIcon from 'vue-material-design-icons/InformationOutline.vue';
import VueTagsInput from '@johmun/vue-tags-input';
import Content from '@/dex-shared/components/content/Content.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxModal from '@/dex-shared/components/px-modal.vue';
import pxTooltip from '@/dex-shared/components/px-tooltip.vue';
import Pagination from '@/components/Pagination.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import ListEditor from '@/views/list/ListEditor.vue';
import ExamEditor from '@/views/exam/ExamEditor.vue';
import KnowledgeAssociation from '@/components/knowledge/KnowledgeAssociation.vue';
import Header from '@/components/Header.vue';

export default Vue.extend({
  components: {
    Content,
    pxCard,
    pxButton,
    Pagination,
    Loading,
    ArrowRightIcon,
    TrashCanOutlineIcon,
    LinkVariantIcon,
    InformationOutlineIcon,
    pxModal,
    pxTooltip,
    ListEditor,
    ExamEditor,
    VueTagsInput,
    KnowledgeAssociation,
    Header,
  },

  data() {
    return {
      currentPage: 0,
      loaded: true,
      searchQuestionContent: '',
      searchingQuestionByContent: false,

      knowledgeFilter: '',
      knowledgeTag: '',

      examApplication: null,
      examApplicationTags: [],
      examApplicationTag: '',
      filteringQuestionsBySource: false,

      filteringQuestionsByKnowledge: false,
      filteringQuestionsByTreeKnowledge: false,

      selectedQuestions: [],
      showListDialog: false,
      showExamDialog: false,

      showDuplicateQuestions: false,
      toMaintain: null,
      toDelete: null,
    };
  },

  computed: {
    ...mapGetters({
      questions: 'questions',
    }),
    ...mapState({
      allExamApplications: (state: any) =>
        state.examApplications.examApplications,
      treeKnowledges: (state: any) => state.treeKnowledges.knowledges,
    }),
    filteredExamApplications() {
      return this.allExamApplications.filter((examApplication: any) => {
        return (
          examApplication.text
            .toLowerCase()
            .indexOf(this.examApplicationTag.toLowerCase() || '') !== -1
        );
      });
    },
    selectingQuestions: function() {
      return this.selectedQuestions.length > 0;
    },
    isFilteringByKnowledge() {
      return this.questions.every(q => !!q.knowledge);
    },
  },

  async mounted() {
    let page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/questoes`);
    }
    this.loaded = false;
    await this.$store.dispatch('PULL_QUESTIONS', {
      searchQuestionContent: this.searchQuestionContent,
      currentPage: this.currentPage,
    });
    await this.$store.dispatch('PULL_EXAM_APPLICATIONS', {
      resultsPerPage: 10000,
    });
    this.loaded = true;
  },

  methods: {
    removeQuestion: async function(questionId: number, index: number) {
      if (
        confirm(
          'Tem certeza que deseja deletar essa questão? Ela não poderá ser recuperada!',
        )
      ) {
        const response = await this.$store.dispatch(
          'REMOVE_QUESTION',
          questionId,
        );
        if (response === true) {
          this.$store.commit('REMOVE_QUESTION', index);
          alert('Questão deletada!');
        } else {
          //TODO analyze the error
          alert(
            'Essa questão não pode ser deletada pois está em alguma prova, lista, ou tem respostas associadas a ela',
          );
        }
      }
    },

    changePage: async function(event: any) {
      this.currentPage = event;
      this.loaded = false;
      await this.$store.dispatch('PULL_QUESTIONS', {
        searchQuestionContent: this.searchQuestionContent,
        currentPage: this.currentPage,
      });
      this.loaded = true;
      this.$router.push(`/questoes/${this.currentPage + 1}`);
    },

    searchQuestionByContent: async function() {
      if (
        this.searchQuestionContent.length > 0 ||
        this.examApplication !== null
      ) {
        this.currentPage = 0;
        this.$router.replace(`/questoes`);
        this.searchingQuestionByContent = true;
        await this.$store.dispatch('PULL_QUESTIONS', {
          searchQuestionContent: this.searchQuestionContent,
          currentPage: this.currentPage,
          examApplicationId: this.examApplication
            ? this.examApplication.id
            : null,
        });
        this.searchingQuestionByContent = false;
      }
    },

    filterQuestionByKnowledge: async function() {
      this.loaded = false;
      this.filteringQuestionsByKnowledge = true;

      if (!this.knowledgeFilter) {
        await this.$store.dispatch('PULL_QUESTIONS', {
          searchQuestionContent: this.searchQuestionContent,
          currentPage: this.currentPage,
        });
      } else {
        await this.$store.dispatch(
          'PULL_QUESTIONS_BY_KNOWLEDGE',
          this.knowledgeFilter,
        );
      }

      this.filteringQuestionsByKnowledge = false;
      this.loaded = true;
    },

    async filterQuestionByTreeKnowledge() {
      this.loaded = false;
      this.filteringQuestionsByTreeKnowledge = true;

      if (this.treeKnowledges.length > 0) {
        await this.$store.dispatch(
          'PULL_QUESTIONS_BY_TREE_KNOWLEDGES',
          this.treeKnowledges,
        );
      } else {
        await this.$store.dispatch('PULL_QUESTIONS', {
          searchQuestionContent: this.searchQuestionContent,
          currentPage: this.currentPage,
        });
      }

      this.filteringQuestionsByTreeKnowledge = false;
      this.loaded = true;
    },

    setExamApplication(examApplication: any) {
      if (examApplication.length > 0) {
        this.examApplication = examApplication[0];
      } else {
        this.examApplication = null;
      }
    },

    toggleDialog(mode: string) {
      if (mode === 'List') {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.showExamDialog = false;
        this.showListDialog = !this.showListDialog;
      } else if (mode === 'Exam') {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.showListDialog = false;
        this.showExamDialog = !this.showExamDialog;
      } else if (mode === 'Duplicate') {
        this.showDuplicateQuestions = !this.showDuplicateQuestions;
      } else {
        this.showListDialog = false;
        this.showExamDialog = false;
        this.showDuplicateQuestions = false;
      }
    },

    mergeQuestions() {
      this.$store.dispatch('MERGE_QUESTIONS', {
        toMaintain: this.toMaintain,
        toDelete: this.toDelete,
      });
      this.showDuplicateQuestions = false;
    },
  },
});
